import Mega_Menu from './mega_menu';
import './mega_menu.scss';
import { create_div } from 'js/utils';

let fullwidth_con = null;

const initial_con = document.querySelector('.mega_menu_init_con');
const body = document.body;

function init(){

    if( !initial_con ) return;
    
    const inner_con = initial_con.children[0];
    if( !inner_con ) return;

    const sub_menus = [];
    for(let i = 0; i < inner_con.children.length; i++ ) {
        sub_menus.push(inner_con.children[i]);
    }
    
    let current = null;

    sub_menus.forEach((el)=>{

        const mega_menu = init_mega_menu(el)

        mega_menu.hooks.add('open', ()=>{

            if( current && mega_menu !== current ) {
                current.close();
            }

            current = mega_menu;
            body.classList.add('mega_menu_open')
        })

        mega_menu.hooks.add('close', ()=>{
            body.classList.remove('mega_menu_open')
        })
        
    })

}
// init();

function init_mega_menu(el){

    if( !el.dataset.trigger ) return;

    const trigger = document.querySelector(el.dataset.trigger);
    if( !trigger ) {
        console.warn(`mega menu trigger el not found ${el.dataset.trigger}`)
        return;
    }

    trigger.classList.add('with_mega_menu');
    
    disable_link(trigger.children[0]);

    let destination;
    if( el.classList.contains('fullwidth') ) {
        // fullwidth
        fullwidth_init();
        destination = fullwidth_con;
    }
    else {
        // align on parent link
        destination = trigger;
    }

    const mega_menu = new Mega_Menu({
        el, trigger, destination,
        // animate_height: true,
    })

    return mega_menu;
}

function fullwidth_init(){
    if( fullwidth_con ) return;
    const fullwidth_container = create_div('mega_menu_fullwidth');
    document.querySelector('.elementor-location-header').append(fullwidth_container);
    fullwidth_con = create_div('inner', fullwidth_container);
}

function disable_link(a){
    a.addEventListener('click', (e)=>e.preventDefault());
}